import { cn } from '@/lib/utils';
import {
  formatShortcut,
  isMacPlatform,
  type ShortcutKey,
} from '@/utility/shortcuts';
import styles from './KeyboardShortcut.module.css';

export interface KeyboardShortcutProps {
  /** e.g. `['mod', 'J']` — `mod` is Cmd on Apple, Ctrl everywhere else. */
  keys: ShortcutKey[];
  className?: string;
}

/**
 * The key-cap hint shown beside whatever a shortcut triggers. Decorative —
 * it is `aria-hidden`, so give the trigger itself an `aria-label` built with
 * `formatShortcut` from `utility/shortcuts`.
 */
export const KeyboardShortcut = ({
  keys,
  className,
}: KeyboardShortcutProps) => {
  const label = formatShortcut(keys, isMacPlatform());

  if (!label) return null;

  return (
    <kbd className={cn(styles.shortcut, className)} aria-hidden="true">
      {label}
    </kbd>
  );
};
